import * as React from "react"
import {Box} from "@mui/material";
import {ButtonIconSeeker} from "@ui-seeker/core";

import { AdminProductReviewBaseTable } from "../@components"
import { useAdminProductReviewListNew } from "../@hooks";
import { adminProductReviewFormIsSkuMappingData } from "../@signals";


export default function AdminProductReviewSkuMappingTable() {
	const { showTable, tableData } = useAdminProductReviewListNew()

	if (!showTable) return <></>

	return <Box id="product-review-sku-mapping-table">
		<AdminProductReviewBaseTable
			title="Product Review Sku Mapped"
			subtitle="List of items behind."
			isSkuMappingTable
			data={tableData}
			options={{
				customToolbar: () => <ButtonIconSeeker
					icon="times"
					onClick={() => adminProductReviewFormIsSkuMappingData.value = []}
					tooltip="Close Table"
				/>
			}}
		/>
	</Box>
}